import { phone_data } from '@/constants/phoneData';

export const countryNameMap = phone_data.country_data;

export const codeMap = phone_data.acode;

export type CountryShortName = keyof typeof countryNameMap;

export const countryList = Object.keys(countryNameMap).map((key) => {
  return {
    value: key,
    name: countryNameMap[key as CountryShortName],
    code: codeMap[key as CountryShortName],
  };
});
